import { Component, Input } from '@angular/core';


@Component({
  moduleId: module.id,
  selector: 'details-page-header',
  templateUrl: 'details-page-header.component.html',
  styleUrls: ['details-page-header.component.scss'],
})
export class DetailsPageHeaderComponent {
  @Input() title: string;
  @Input() subTitle: string;
  @Input() headerColor: string = 'darkred';
  @Input() imageURL: string;
  @Input() isEditModeStyle: boolean = false;
}
